/* Glambe cart: the checkout button opens a small chooser: Cash on delivery (our COD form), Pay by card, Pay with Tamara. */
(function () {
  if (window.__gbCart) return; window.__gbCart = 1;
  var NOT_BUNDLE = ['44355927998600', '44355928490120'];
  var TRIO = ['korean-silk-lifting-peptide-ampoule', 'dr-melaxin-tranexamic-cream-skin-freckle-cream-anti-pigmetation-for-all-skin', 'dr-melaxin-eyephalt-eye-bag-cream'];
  var bypass = false, busy = false, box = null;
  var st = document.createElement('style');
  st.textContent = '.gbch{position:fixed;inset:0;z-index:2147483200;display:flex;align-items:flex-end;justify-content:center;background:rgba(58,45,92,.45);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);opacity:0;transition:opacity .25s cubic-bezier(.2,.8,.2,1)}' +
    '.gbch.on{opacity:1}.gbch[hidden]{display:none}' +
    '.gbch__s{width:min(440px,100%);background:#FBFAFF;border-radius:24px 24px 0 0;padding:20px 18px max(22px,env(safe-area-inset-bottom));font-family:Inter,system-ui,sans-serif;color:#3A2D5C;transform:translateY(40px);transition:transform .3s cubic-bezier(.2,.8,.2,1)}' +
    '.gbch.on .gbch__s{transform:none}' +
    '@media(min-width:640px){.gbch{align-items:center}.gbch__s{border-radius:24px}}' +
    '.gbch__h{display:flex;justify-content:space-between;align-items:center;margin:0 0 14px;font-size:18px;font-weight:600}' +
    '.gbch__x{width:36px;height:36px;border-radius:50%;border:0;background:#EFE9FA;color:#3A2D5C;font-size:20px;cursor:pointer}' +
    '.gbch__b{display:flex;flex-direction:column;align-items:flex-start;gap:2px;width:100%;margin:0 0 10px;padding:14px 16px;border-radius:16px;border:1px solid #E9E1F7;background:#fff;color:#3A2D5C;font:inherit;text-align:start;cursor:pointer}' +
    '.gbch__b b{font-size:15px;font-weight:600}.gbch__b span{font-size:12px;color:#7A6E9A}' +
    '.gbch__b--p{background:#3A2D5C;border-color:#3A2D5C;color:#fff}.gbch__b--p span{color:#E4DAF3}' +
    '.gbch__b[disabled]{opacity:.6}';
  document.head.appendChild(st);
  function uae() { var c = ''; try { c = (window.Shopify && Shopify.country) || ''; } catch (e) {} return c === 'AE' || c === 'SA'; }
  function ui() {
    if (box) return box;
    box = document.createElement('div'); box.className = 'gbch'; box.hidden = true;
    box.innerHTML = '<div class="gbch__s" role="dialog" aria-label="Choose how to pay"><div class="gbch__h"><span>How would you like to pay?</span><button type="button" class="gbch__x" aria-label="Close">&times;</button></div>' +
      '<button type="button" class="gbch__b gbch__b--p" data-k="cod"><b>Cash on delivery</b><span>Pay when it arrives · Free delivery</span></button>' +
      '<button type="button" class="gbch__b" data-k="card"><b>Pay by card</b><span>Secure online checkout</span></button>' +
      '<button type="button" class="gbch__b" data-k="tamara" ' + (uae() ? '' : 'hidden') + '><b>Pay with Tamara</b><span>Pay in instalments (UAE &amp; KSA)</span></button></div>';
    document.body.appendChild(box);
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('.gbch__x')) return close();
      var b = e.target.closest('.gbch__b'); if (!b) return;
      var k = b.getAttribute('data-k');
      if (k === 'cod') cod(b); else { close(); go(); }
    });
    return box;
  }
  function open() { ui(); box.hidden = false; requestAnimationFrame(function () { box.classList.add('on'); }); }
  function close() { if (!box) return; box.classList.remove('on'); setTimeout(function () { box.hidden = true; }, 260); }
  function go() { location.href = '/checkout'; }
  function cod(btn) {
    if (busy) return; busy = true; btn.disabled = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      busy = false; btn.disabled = false;
      var it = (c.items || []).filter(function (x) { return x.quantity > 0; });
      if (!it.length) return close();
      if (!window.gbFormOpen) return go();
      var o = { clearCart: true, tam: true, fail: go };
      if (it.length === 1) {
        if (it[0].quantity > 3) return go();
        o.variantId = String(it[0].variant_id); o.qty = it[0].quantity; close(); return window.gbFormOpen(o);
      }
      var handles = it.map(function (x) { return x.handle; });
      var ok = it.every(function (x) { return x.quantity === 1 && NOT_BUNDLE.indexOf(String(x.variant_id)) < 0; }) && it.length <= 5 &&
        handles.filter(function (h, i) { return handles.indexOf(h) === i; }).length === it.length;
      if (!ok) return go();
      var trio = it.length === 3 && TRIO.every(function (h) { return handles.indexOf(h) > -1; });
      o.bundle = trio ? 'GLOWTRIO' : (it.length === 2 ? 'GLAMBEMIX15' : 'GLAMBEMIX25');
      o.pct = trio ? 33 : (it.length === 2 ? 15 : 25);
      o.variantId = String(it[0].variant_id);
      o.items = it.map(function (x) { return { variantId: String(x.variant_id), n: x.product_title, price: x.price / 100 }; });
      close(); window.gbFormOpen(o);
    }).catch(function () { busy = false; btn.disabled = false; go(); });
  }
  document.addEventListener('click', function (e) {
    if (bypass || !e.target.closest) return;
    var b = e.target.closest('button[name="checkout"],[class*="checkout-button"],a[href="/checkout"]');
    if (!b || b.closest('.gbch')) return;
    e.preventDefault(); e.stopImmediatePropagation(); open();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (bypass || !f || !f.action || f.action.indexOf('/cart') < 0) return;
    var s = e.submitter; if (s && s.name === 'checkout') { e.preventDefault(); e.stopImmediatePropagation(); open(); }
  }, true);
})();
